const { uvPrintingGuide } = require('../src/data/uv-printing-guide')
const { uvPrintingCostGuide } = require('../src/data/uv-printing-cost-guide')
const { printerCostGuide } = require('../src/data/printer-cost-guide')
const { biggestPrintersGuide } = require('../src/data/biggest-printers-guide')
const { printCostGuide } = require('../src/data/print-cost-guide')
const { printCostCalculator } = require('../src/data/print-cost-calculator')
const {
  customTrophyCostGuide,
} = require('../src/data/custom-trophy-cost-guide')
const { siteUrl } = require('../src/utils/siteConfig')
const { laserEngravingFacts } = require('./laser-engraving-facts')
const { onsiteEngravingFacts } = require('../src/data/onsite-engraving')
const { fantasyTrophy } = require('../src/data/fantasy-trophy')
const {
  crownAwardsAlternatives,
} = require('../src/data/crown-awards-alternatives')
const {
  fantasyFootballPunishments,
} = require('../src/data/fantasy-football-punishments')
const {
  fantasyLeagueNames,
} = require('../src/data/fantasy-football-league-names')
const { customFigurines } = require('../src/data/custom-figurines')
const { petFigurines } = require('../src/data/pet-figurines')
const { customBobbleheads } = require('../src/data/custom-bobbleheads')
const { replica } = require('../src/data/replica')
const { trophyAwardIdeas } = require('../src/data/trophy-award-ideas')
const { petMemorialIdeas } = require('../src/data/pet-memorial-ideas')
const { imageTo3dGuide } = require('../src/data/image-to-3d-model-guide')
const { championshipBelt } = require('../src/data/championship-belt')
const { dealToys } = require('../src/data/deal-toys')
const { logoTrophies } = require('../src/data/logo-trophies')
const { christmasOrnaments } = require('../src/data/christmas-ornaments')
const { itemPages } = require('../src/data/item-pages')
const { agencyPages } = require('../src/data/agency-pages')
const { nycPrintingCompared } = require('../src/data/nyc-3d-printing-compared')
const {
  cities: printingCities,
} = require('../src/data/best-3d-printing-cities')
const { page: printingPage } = require('../src/data/printing-service')
const { page: printingNycPage } = require('../src/data/printing-nyc')
const { pages: cuttingPages } = require('../src/data/cutting-services')
const { pages: productsStudiosPages } = require('../src/data/products-studios')
const { processPages } = require('../src/data/printing-processes')
const { cities: printingCityPages } = require('../src/data/printing-cities')
const { projectServices } = require('../src/data/project-services')

const legacySelector = 'link[rel="canonical"][data-basehost][data-baseprotocol]'
const uvGuidePaths = new Set([
  '/custom-vinyl-figures-prototyping/',
  '/custom-toy-character-builder/',
  '/services/custom-trophy/',
  printingPage.path,
  printingNycPage.path,
  ...Object.values(cuttingPages).map((page) => page.path),
  ...processPages.map(({ page }) => page.path),
  ...Object.values(printingCityPages).map((city) => city.page.path),
  ...projectServices.map((service) => service.page.path),
  '/services/3d-scanning/',
  '/3d-scanning-nyc/',
  '/3d-scanning-services-los-angeles/',
  '/3d-scanning-service-las-vegas/',
  '/services/3d-modeling/',
  fantasyTrophy.path,
  customFigurines.path,
  petFigurines.path,
  customBobbleheads.path,
  replica.path,
  championshipBelt.path,
  dealToys.path,
  logoTrophies.path,
  christmasOrnaments.path,
  ...itemPages.map((page) => page.path),
  ...agencyPages.map((page) => page.path),
  uvPrintingGuide.path,
  uvPrintingCostGuide.path,
  printerCostGuide.path,
  biggestPrintersGuide.path,
  printCostGuide.path,
  printCostCalculator.path,
  customTrophyCostGuide.path,
  crownAwardsAlternatives.path,
  nycPrintingCompared.path,
  ...Object.values(printingCities).map((city) => city.guide.path),
  trophyAwardIdeas.path,
  fantasyFootballPunishments.path,
  petMemorialIdeas.path,
  imageTo3dGuide.path,
  fantasyLeagueNames.path,
  laserEngravingFacts.path,
  laserEngravingFacts.nationalPath,
  laserEngravingFacts.metalPath,
  '/services/laser-engraving/texas/houston/',
  '/services/laser-engraving/california/los-angeles/',
  onsiteEngravingFacts.path,
  ...productsStudiosPages.map((page) => page.path),
])

// These guides and engraving pages own canonicals through Gatsby Head. Remove only the legacy
// plugin's duplicate, never Gatsby-managed tags or other pages' canonicals.
const filterUVGuideHeadComponents = (pathname, components) => {
  if (!uvGuidePaths.has(pathname)) return components

  return components.filter(
    (component) =>
      !(
        component?.type === 'link' &&
        component.props.rel === 'canonical' &&
        component.props['data-basehost'] &&
        component.props['data-baseprotocol']
      )
  )
}

const removeUVGuideLegacyCanonical = (location, document) => {
  if (!uvGuidePaths.has(location.pathname)) return

  document
    .querySelectorAll(legacySelector)
    .forEach((element) => element.remove())
}

// Client-side navigation does not rerun SSR. Put the original plugin-owned
// element back before leaving these guides so its usual onRouteUpdate behavior
// remains intact everywhere else (including pages without a Head canonical).
const restoreLegacyCanonicalAfterUVGuide = (
  { location, prevLocation },
  document
) => {
  if (
    !uvGuidePaths.has(prevLocation?.pathname) ||
    uvGuidePaths.has(location.pathname) ||
    document.querySelector(legacySelector)
  ) {
    return
  }

  const base = new URL(siteUrl)
  const element = document.createElement('link')
  element.setAttribute('rel', 'canonical')
  element.setAttribute('data-baseprotocol', base.protocol)
  element.setAttribute('data-basehost', base.host)
  element.setAttribute(
    'href',
    `${base.origin}${location.pathname}${location.search || ''}${location.hash || ''}`
  )
  document.head.insertBefore(element, document.head.firstChild)
}

module.exports = {
  filterUVGuideHeadComponents,
  removeUVGuideLegacyCanonical,
  restoreLegacyCanonicalAfterUVGuide,
}
